"use client";
import {
  usePopoverArrow
} from "../__chunks/7DP25ROA.js";
import "../__chunks/QFL5V2DO.js";
import {
  useTooltipContext
} from "../__chunks/V3XGKTI7.js";
import "../__chunks/BEBUB5QN.js";
import "../__chunks/M6ZUVZPG.js";
import "../__chunks/32IPIQBR.js";
import "../__chunks/EQMNTDLB.js";
import {
  createElement,
  createHook,
  forwardRef
} from "../__chunks/PTCNA5XT.js";
import "../__chunks/WX6L4ACS.js";
import "../__chunks/SK3NAZA3.js";
import {
  __objRest,
  __spreadValues
} from "../__chunks/3YLGPPWQ.js";

// src/tooltip/tooltip-arrow.tsx
import { invariant } from "@ariakit/core/utils/misc";
var TagName = "div";
var useTooltipArrow = createHook(
  function useTooltipArrow2(_a) {
    var _b = _a, { store, size = 16 } = _b, props = __objRest(_b, ["store", "size"]);
    const context = useTooltipContext();
    store = store || context;
    invariant(
      store,
      process.env.NODE_ENV !== "production" && "TooltipArrow must be wrapped in a Tooltip component."
    );
    props = usePopoverArrow(__spreadValues({ store, size }, props));
    return props;
  }
);
var TooltipArrow = forwardRef(function TooltipArrow2(props) {
  const htmlProps = useTooltipArrow(props);
  return createElement(TagName, htmlProps);
});
export {
  TooltipArrow,
  useTooltipArrow
};
